import { RushGlide } from './_rush-glide';
import { isMobile } from '../services/mql-service';

export class MeetTheTeam extends DrupalBehavior {
  onContent(context) {
    const meetTheTeamComponents = context.querySelectorAll('.meet-the-team');
    meetTheTeamComponents.forEach((meetTheTeam) => {
      const items = meetTheTeam.querySelectorAll('.meet-the-team--item');

      items.forEach((item) => {
        const showMore = item.querySelector('.meet-the-team--item--show');
        const hidden = item.querySelector('.meet-the-team--item--hidden');
        if (hidden) {
          showMore.addEventListener(
            'click',
            () => {
              if (showMore.getAttribute('aria-expanded') === 'false') {
                hidden.classList.add('visible');
                showMore.setAttribute('aria-expanded', true);
                showMore.classList.add('hidden');
                showMore.textContent = 'Show Fewer Locations';
              } else {
                hidden.classList.remove('visible');
                showMore.setAttribute('aria-expanded', false);
                showMore.classList.remove('hidden');
                showMore.textContent = 'Show More Locations';
              }
            },
            true
          );
        }
      });

      const isLocationPage =
        meetTheTeam.querySelector('.meet-the-team--slider-wrap') !== null;
      if (isLocationPage) {
        this.setUpMeetTheTeamSlider(meetTheTeam);
      }
    });
  }

  setUpMeetTheTeamSlider(meetTheTeam) {
    const rushGlide = new RushGlide();
    if (isMobile()) {
      this.setUpMobileSlider(rushGlide, meetTheTeam);
    } else {
      this.setUpDesktopSlider(rushGlide, meetTheTeam);
    }
  }

  setUpMobileSlider(rushGlide, meetTheTeam) {
    const mobilePeekPixels = 64;
    const slider = meetTheTeam.querySelector(
      '.mobile-only .meet-the-team--list'
    );
    rushGlide.setUpGlide(slider, {
      perView: 1,
      gap: 24,
      startPeek: { before: 0, after: mobilePeekPixels },
      endPeek: { before: mobilePeekPixels, after: 0 },
      customArrows: {
        leftArrow: meetTheTeam.querySelector('.glide__arrow--left'),
        rightArrow: meetTheTeam.querySelector('.glide__arrow--right'),
      },
    });
  }

  setUpDesktopSlider(rushGlide, meetTheTeam) {
    const desktopPadding = 20;

    const slider = meetTheTeam.querySelector(
      '.desktop-only .meet-the-team--list'
    );
    const numOfItems = slider.querySelectorAll('.meet-the-team--item').length;
    if (numOfItems > 3) {
      rushGlide.setUpGlide(slider, {
        perView: 1,
        startPeek: desktopPadding,
        endPeek: desktopPadding,
        gap: desktopPadding + 1,
      });
    } else {
      meetTheTeam.classList.add('no-glide');
    }
  }
}
DrupalBehavior.register('rush_theme.components', 'meet_the_team', MeetTheTeam);
